export default [
  {
    fileName: 'articles-of-incorporation',
    fileExtension: '.jpeg',
    dbFieldName: 'carrierHasUploadedArticlesOfIncorporation',
    displayName: 'Articles of Incorporation',
    fieldName: 'articlesOfIncorporation'
  },
  {
    fileName: 'drivers-license',
    fileExtension: '.jpeg',
    dbFieldName: 'carrierHasUploadedDriversLicense',
    displayName: 'Drivers License',
    fieldName: 'driversLic'
  },
  {
    fileName: 'insurance-card',
    fileExtension: '.jpeg',
    dbFieldName: 'carrierHasUploadedInsurance',
    displayName: 'Insurance Card',
    fieldName: 'insuranceCard'
  },
  { fileName: 'w9', fileExtension: '.jpeg', dbFieldName: 'carrierHasUploadedW9', displayName: 'W9', fieldName: 'w9' },
  {
    fileName: 'voided-check',
    fileExtension: '.jpeg',
    dbFieldName: 'carrierHasUploadedVoidedCheck',
    displayName: 'Voided Check',
    fieldName: 'voidedCheck'
  }
]
